import Theme from '@styles/Theme';
import { scrollbarStyle } from '@styles/variants/scrollbar';
import styled, { css } from 'styled-components';

const floatingDirMap = {
  bottom: css`
    bottom: 32px;
  `,
  top: css`
    top: 16px;
    right: 16px;
  `,
};

const mobileFloatingDirMap = {
  bottom: css`
    bottom: 0;
  `,
  top: css`
    top: 0;
  `,
};
export const DragContainer = styled.div<{
  open?: boolean;
  floatingDir?: keyof typeof floatingDirMap;
  width?: number;
}>`
  background: var(--backgroundColor);
  border-radius: 16px;
  position: fixed;
  padding: 8px 16px 16px 16px;
  flex-direction: column;
  z-index: 100;

  box-shadow: ${Theme.shadow.dropdown};
  width: 400px;
  width: ${({ width }) => (width ? `${width}px` : '400px')};
  overflow: hidden;
  backdrop-filter: blur(24px);
  ${({ floatingDir = 'top' }) => floatingDirMap[floatingDir]}
  display: ${({ open = true }) => (open ? 'block' : 'none')};
  ${scrollbarStyle}

  @media (max-width: 480px) {
    width: 100%;
    left: 0;
    right: 0;
    max-height: 300px;
    ${({ floatingDir = 'top' }) => mobileFloatingDirMap[floatingDir]}
  }
`;
